const utils = {
	storage_string: {
		conversion_failed: "Conversie van bytes gefaald",
	},
};

export default utils;
